import { isUserMessage } from '@cascade/react/conversations';
import type { TMessage } from '@cascade/react/conversations';
import type { TChatSuggestion } from '@cascade/ui-library';
import type { TFileFeedback } from './AgentChat.types.ts';
import type { TAttachmentFailure } from './use-attachments/index.ts';
import { buildSuggestions } from '#helpers/index.ts';

export const getPrompts = (
  followUps: string[],
  suggestedQuestions: string[],
  hasMessages: boolean,
): TChatSuggestion[] => {
  if (followUps.length > 0) {
    return buildSuggestions(followUps);
  }

  if (hasMessages) {
    return [];
  }

  return buildSuggestions(suggestedQuestions);
};

export const buildFileFeedback = (
  failures: TAttachmentFailure[],
  translateError: (error: unknown) => string,
): TFileFeedback => {
  const feedback: TFileFeedback = new Map();

  failures.forEach(({ fileKey, error }) => {
    feedback.set(fileKey, {
      feedbackLevel: 'danger',
      feedbackText: translateError(error),
    });
  });

  return feedback;
};

export const hasAnsweredAsk = (messages: TMessage[]): boolean =>
  messages.some(
    (message) =>
      !isUserMessage(message) &&
      message.status === 'complete' &&
      message.requestId !== undefined,
  );
